export default __webpack_public_path__ + "src/assets/verify-message.eca961d038ce994d39732d44de42b682.svg";